import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Drawer, Grid, Typography, Button, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2)
  },
  actions: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  }
}));

interface TableEditBarProps {
  selected: string[],
  className?: string,
  items: {
    onClick: React.MouseEventHandler<HTMLButtonElement>,
    label: string,
    Icon: React.FC<{className?: string}>
  }[]
}

const TableEditBar = (props: TableEditBarProps) => {
  const {
    selected,
    className,
    items,
    ...rest
  } = props;

  const classes = useStyles();
  const open = selected.length > 0;

  return (
    <Drawer
      anchor="bottom"
      open={open}
      // eslint-disable-next-line react/jsx-sort-props
      PaperProps={{ elevation: 1 }}
      variant="persistent"
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Grid
          alignItems="center"
          container
          spacing={2}
        >
          <Grid
            item
            md={3}
          >
            <Typography
              color="textSecondary"
              variant="subtitle1"
            >
              {selected.length} selected
            </Typography>
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <div className={classes.actions}>
              {items.map((i) => <Button
                key={i.label}
                onClick={i.onClick}
              >
                <i.Icon className={classes.buttonIcon} />
                {i.label}
              </Button>)}
            </div>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

TableEditBar.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  selected: PropTypes.array.isRequired
};

export default TableEditBar;
